import React, { useState, useEffect, useRef } from "react";
import { Button, Col, Row, Form, Container } from "react-bootstrap";


export default function SaveChanges(props) {
  

  return (
    <>
      <Button
      className="api-button"
        style={{
          paddingTop: "8px",
          paddingBottom: "8px",
          paddingLeft: "22px",
          paddingRight: "22px",
          marginTop: "25px",
          width: "100%"
        }}
        id="api-access-save-btn"
        variant="success"
        type="submit"
      >
        Save
      </Button>
    </>
  )
}